<template>
  <div v-if="show" :class="['popupIcon', showRedPoint && 'withRedPoint']">
    <Image :src="popupIcon?.picture" class="size-full" @click="[handleJumpLink(popupIcon, $router), recordClick()]" />
  </div>
</template>

<script setup lang="ts">
  import { handleJumpLink } from '@/utils'
  import { useHomeBannersAndTexts, useUserInfo, useActivityList } from '@/store'

  const popupIcon = computed(() => useHomeBannersAndTexts().suspendIcon);

  const show = ref(false)
  const showRedPoint = ref(false)

  const recordClick = () => {
    sessionStorage.clickedFloating = 1
  }

  let tid;
  const check = (checker, condition) => {
    if (popupIcon.value?.state === 'Enabled') {
      if (condition == 'ALWAYS') {
        checker.value = true
      } else if (condition == 'NOT_LOGIN') {
        if (!useUserInfo().isLoggedin) checker.value = true
      } else if (condition == 'LOGIN_AFTER') {
        if (useUserInfo().isLoggedin) checker.value = true
      } else {
        if (checker === show) {
          if (condition == 'ACTIVITY') {
            const activityId = popupIcon.value.activityId
            if (activityId) {
              const activity = useActivityList().getActivityById(activityId)
              if (activity && activity.status === 'Active') checker.value = true
            }
          } else if (condition > 0) {
            checker.value = true
            tid = setTimeout(() => {
              checker.value = false
            }, condition * 60 * 1000)
          }
        } else if (checker === showRedPoint) {
          if (condition == 'NO_CLICK') {
            if (sessionStorage.clickedFloating != 1) checker.value = true
          }
        }
      }
    } else {
      checker.value = false
    }
  }

  check(show, popupIcon.value?.displayCondition)

  check(showRedPoint, popupIcon.value?.redDotHint)
  
  onUnmounted(() => {
    clearTimeout(tid)
  })
</script>

<style scoped>
  .popupIcon{
    @apply size-20 fixed-b-22 left-1/2 z-[100] -ml-[calc(min(100%,var(--max-width))/2-10px)];
  }
</style>